module.exports = __webpack_public_path__ + "img/mention-in-post.e4638d3f.png";